import { Component, Inject, PLATFORM_ID, OnInit, OnDestroy, NgZone } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-nabvar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './nabvar.html',
  styleUrls: ['./nabvar.scss'],
})
export class Nabvar implements OnInit, OnDestroy {
  isScrolled = false;

  constructor(@Inject(PLATFORM_ID) private platformId: any, private ngZone: NgZone) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        window.addEventListener('scroll', this.onWindowScroll);
      });
      this.onWindowScroll();

      // Cerrar el menú al hacer clic en un enlace
      this.setupNavbarClose();
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('scroll', this.onWindowScroll);
    }
  }

  private onWindowScroll = () => {
    if (isPlatformBrowser(this.platformId)) {
      const scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollPosition > 50 !== this.isScrolled) {
        this.ngZone.run(() => {
          this.isScrolled = scrollPosition > 50;
        });
      }
    }
  };

  private setupNavbarClose() {
    if (isPlatformBrowser(this.platformId)) {
      // Cerrar el navbar al hacer clic en cualquier enlace
      const navLinks = document.querySelectorAll('.nav-link');
      const navbarToggler = document.querySelector('.navbar-toggler');
      const navbarCollapse = document.querySelector('.navbar-collapse');

      navLinks.forEach((link) => {
        link.addEventListener('click', () => {
          // Verificar si el navbar está expandido (en dispositivos móviles)
          if (navbarCollapse && navbarCollapse.classList.contains('show')) {
            // Cerrar el navbar
            navbarCollapse.classList.remove('show');

            // Cambiar el estado del botón toggler
            if (navbarToggler) {
              navbarToggler.setAttribute('aria-expanded', 'false');
            }
          }
        });
      });
    }
  }
}
